import { PublicPage } from 'api/website';

import { useContentHomePageMeta } from './useContentHomePageMeta';

type Props = {
  content: PublicPage;
};

export function useContentHasPostSearchToolbar({ content }: Props) {
  const { subsiteHasHomePage } = useContentHomePageMeta({ content });

  // Search bar at the top of page only should appear on "content pages"
  return subsiteHasHomePage && content.hasSearch;
}
